module.exports = __webpack_public_path__ + "img/apple-app-store-icon.7ab4974d.png";